import { IonIcon } from '@ionic/react';
import styles from './stats.module.css';

/** Small stat card: icon chip, value, muted label and an accent sub line. */
const StatTile: React.FC<{ value: number; label: string; sub: string; icon: string }> = ({ value, label, sub, icon }) => (
    <div className={styles.card + ' ' + styles.statTile}>
        <span className={styles.statTileIcon}><IonIcon icon={icon} /></span>
        <div>
            <div className={styles.statTileValue}>{value}</div>
            <div className={styles.mutedSmall}>{label}</div>
            <div className={styles.statTileSub}>{sub}</div>
        </div>
    </div>
);

export default StatTile;
